import styles from './channelStripSkeleton.module.scss';

const {
    mainWrapper,
    leftSideContent,
    rightSideContent,
    leftImage,
    leftContentWrapper,
    eyeBrow,
    title,
    subTitle,
    secondarySubTitle,
    rightImage,
    rightContentWrapper,
} = styles;

export function ChannelStripSkeleton() {
    return (
        <div className={mainWrapper}>
            <div className={leftSideContent}>
                <div className={leftImage}></div>
                <div className={leftContentWrapper}>
                    <div className={eyeBrow}></div>
                    <div className={title}></div>
                    <div className={subTitle}></div>
                    <div className={secondarySubTitle}></div>
                </div>
            </div>
            <div className={rightSideContent}>
                <div className={rightImage}></div>
                <div className={rightContentWrapper}>
                    <div className={eyeBrow}></div>
                    <div className={title}></div>
                </div>
            </div>
        </div>
    );
}
